import React, { useState } from 'react';
import Sidebar from './Sidebar';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-slate-100">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(c => !c)} />

      {/* Main content — offset for sidebar only; pages own their top header */}
      <main
        className={`
          min-h-screen flex flex-col
          transition-all duration-200
          ${collapsed ? 'pl-16' : 'pl-60'}
        `}
      >
        {children}
      </main>
    </div>
  );
};

export default AppLayout;
